import { 
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,

    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,
    USER_REGISTER_RESET,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,
    USER_DETAILS_RESET,

    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,
    USER_UPDATE_PROFILE_RESET,

    REGISTER_LICENSE_REQUEST,
    REGISTER_LICENSE_SUCCESS,
    REGISTER_LICENSE_FAIL,

    SUBMIT_EXPERIENCE_REQUEST,
    SUBMIT_EXPERIENCE_SUCCESS,
    SUBMIT_EXPERIENCE_FAIL,
    SUBMIT_EXPERIENCE_RESET,

    GET_ALL_USERS_REQUEST,
    GET_ALL_USERS_SUCCESS,
    GET_ALL_USERS_FAIL,

    GET_USER_LOCATION_REQUEST,
    GET_USER_LOCATION_SUCCESS,
    GET_USER_LOCATION_FAIL,

    USER_RESET_PASSWORD_REQUEST,
    USER_RESET_PASSWORD_SUCCESS,
    USER_RESET_PASSWORD_FAIL,

    CONFIRM_REGISTRATION_REQUEST,
    CONFIRM_REGISTRATION_SUCCESS,
    CONFIRM_REGISTRATION_FAIL,
    OPEN_CREATE_PCR_DIALOG,
    OPEN_CREATE_PCR_DIALOG_RESET,

} from '../constants/userConstants'

export const userLoginReducer = (state = { }, action) => {
    switch(action.type) {
        case USER_LOGIN_REQUEST:
            return {loading:true }

        case USER_LOGIN_SUCCESS:
            return {loading:false, userInfo: action.payload }

        case USER_LOGIN_FAIL:
            return {loading:false, error: action.payload }

        case USER_LOGOUT:
            return {}

        default:
            return state
    }
}

export const userRegisterReducer = (state = { }, action) => {
    switch(action.type) {
        case USER_REGISTER_REQUEST:
            return {loading:true }

        case USER_REGISTER_SUCCESS:
            return {loading:false, registered: true }

        case USER_REGISTER_FAIL:
            return {loading:false, error: action.payload }

        case USER_LOGOUT:
            return {}

        case USER_REGISTER_RESET:
            return { loading: false, registered: false }

        default:
            return state
    }
}

export const userDetailsReducer = (state = { user: {} }, action) => {
    switch(action.type) {
        case USER_DETAILS_REQUEST:
            return { ...state, loading:true }

        case USER_DETAILS_SUCCESS:
            return { loading:false, userDetails: action.payload }

        case USER_DETAILS_FAIL:
            return { loading:false, error: action.payload }

        case USER_DETAILS_RESET:
            return { }

        default:
            return state
    }
}

export const userUpdateProfileReducer = (state = { }, action) => {
    switch(action.type) {
        case USER_UPDATE_PROFILE_REQUEST:
            return { updating: true }

        case USER_UPDATE_PROFILE_SUCCESS:
            return { updating: false, updated: true }

        case USER_UPDATE_PROFILE_FAIL:
            return {updating:false, updateError: action.payload }

        case USER_UPDATE_PROFILE_RESET:
            return { updated: false }

        default:
            return state
    }
}

export const registerLicenseReducer = (state = { }, action) => {
    switch(action.type) {
        case REGISTER_LICENSE_REQUEST:
            return { loading: true, lookedUp: false }

        case REGISTER_LICENSE_SUCCESS:
           return { loading: false, licenseInfo: action.payload, lookedUp: true }

        case REGISTER_LICENSE_FAIL:
            return { loading: false, error: action.payload, lookedUp: true }

        default:
            return state
    }
}

export const submitExperienceReducer = (state = { }, action) => {
    switch(action.type) {
        case SUBMIT_EXPERIENCE_REQUEST:
            return { loading: true }

        case SUBMIT_EXPERIENCE_SUCCESS:
           return { loading: false, success: true }

        case SUBMIT_EXPERIENCE_FAIL:
            return { loading: false, error: action.payload }

        case SUBMIT_EXPERIENCE_RESET:
            return { }

        default:
            return state
    }
}

export const getAllUsersReducer = (state = { }, action) => {
    switch (action.type) {
        case GET_ALL_USERS_REQUEST:
            return { loading: true }

        case GET_ALL_USERS_SUCCESS:
            return { loading: false, users: action.payload }

        case GET_ALL_USERS_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}

export const getUserLocationReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_USER_LOCATION_REQUEST:
            return { loading: true }

        case GET_USER_LOCATION_SUCCESS:
            return { loading: false, userLocation: action.payload }

        case GET_USER_LOCATION_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}

export const getResetPasswordReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_RESET_PASSWORD_REQUEST:
            return { updating: true }

        case USER_RESET_PASSWORD_SUCCESS:
            return { updating: false, success: true }

        case USER_RESET_PASSWORD_FAIL:
            return { updating: false, error: action.payload }

        default:
            return state
    }
}

export const confirmRegistrationReducer = (state = {}, action) => {
    switch (action.type) {
        case CONFIRM_REGISTRATION_REQUEST:
            return { confirming: true }

        case CONFIRM_REGISTRATION_SUCCESS:
            return { confirming: false }

        case CONFIRM_REGISTRATION_FAIL:
            return { confirming: false, error: action.payload}

        default:
            return state
    }
}

export const getOpenPCRCreateDialogReducer = (state = {}, action) => {
    switch (action.type) {
        case OPEN_CREATE_PCR_DIALOG:
            return { openDialogRequest: true }
        case OPEN_CREATE_PCR_DIALOG_RESET:
            return { openDialogRequest: false }
        default:
            return state
    }
}